export const invoices = {

    state: {

        invoices: [

            {
                id: 1,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: false,
                cost: '20.000.00'
            },
            {
                id: 2,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: true,
                cost: '10.000.00'
            },
            {
                id: 3,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: true,
                cost: '15.000.00'
            },
            {
                id: 4,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: false,
                cost: '12.000.00'
            },
            {
                id: 5,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: false,
                cost: '8.000.00'
            },
            {
                id: 6,
                number: '123123',
                clinic: 'ASNC',
                date: '00/00/00',
                isPaid: true,
                cost: '4.000.00'
            }

        ]

    },

    mutations: {},

    actions: {}

}